module.exports = __webpack_public_path__ + "static/media/Shells_Landing_Ipad.67ca9b68.png";